import Card from '../../components/Card/Card'
import NavBar from '../../components/NavBar/NavBar'
import Footer from '../../components/Footer/Footer'
import { useEffect, useState } from 'react'
import '../../styles/Sacraments.css'
import Spinner from '../../components/Spinner/Spinner'

export default function ChristianSymbols() {

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;

    async function fetchData() {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch('https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Files/christian_symbols.json', {
          method: 'GET',
          cache: 'force-cache',
          
          headers: {
            'Cache-Control': 'max-age=3600, public'
                      
          },
          signal,
        });

        if (!res.ok) {throw new Error(`Erro ${res.status}: Não foi possível carregar os símbolos`);}

        const json = await res.json(); // Recebo fetch do json aqui e coloco no data
        setData(json);
      } catch (err) {
        if (err.name === 'AbortError') {
          // fetch abortado — não é um "erro" real
          return;
        }
        console.error(err);
        setError(err.message || 'Erro desconhecido ao carregar dados');
      } finally {
        if(!signal.aborted) {

            setLoading(false);
        }
      }
    }
    fetchData();

    return () => {
      controller.abort();
    };
  }, []); // rodar só no mount

  return (
    <div>
      <NavBar />

      <div className="card-container">
        {loading ? (
          <Spinner />
        ) : error ? (
          <div role="alert" style={{ padding: 16 }}>
            <p>Ocorreu um erro ao carregar os símbolos.</p>
            <pre style={{ whiteSpace: 'pre-wrap' }}>{error}</pre>
          </div>
        ) : data.length > 0 ? (
          data.map((item) => (

            <Card
              key={item.id ?? item.Nome}
              Nome={item.Nome}
              Descricao={item.Descricao}
              Imagem={item.Imagem}
            />
          ))
        ) : (
          // caso o JSON carregue com array vazio
          <p>Nenhum símbolo encontrado.</p>
        )}
      </div>
      <Footer />
    </div>
)
}